import axios from 'axios'
import { reg } from 'api/config'
import { inWechat, isWeCom, isMiniBankInsurance } from './config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'

const wxUrl = `https://wx.winbaoxian.${reg ? 'com' : 'cn'}`
const checkUrl = `${wxUrl}/box/wx/checkUserInfoExists`
const redirectUrl = `${wxUrl}/box/wx/authorizeUserInfoWithCode?return_url=RETURN_URL`
const oauthUrl =
  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=APP_ID&redirect_uri=REDIRECT_URL&response_type=code&scope=snsapi_userinfo&state=STATE'

export default async ({ token, wxMpAppid, componentAppid }) => {
  if (!inWechat || isWeCom || isMiniBankInsurance) {
    return Promise.resolve()
  }
  // returnUrl
  // 在分享时已经带上
  // {
  //   wxMpAppid: wxMpAppid,
  //   component_appid: componentAppid
  // }
  const returnUrl = getUrlByAddingParam({ token }, location.href)
  // goOauthUrl
  let goOauthUrl = oauthUrl
    .replace(/APP_ID/, wxMpAppid)
    .replace(
      /REDIRECT_URL/,
      encodeURIComponent(
        redirectUrl.replace(/RETURN_URL/, encodeURIComponent(returnUrl))
      )
    )
  // #wechat_redirect 参数必须在#wechat_redirect前
  goOauthUrl += (componentAppid ? `&component_appid=${componentAppid}` : '') + '#wechat_redirect'
  try {
    const { data: { code } } = await axios
      .create()
      .get(checkUrl, {
        params: {
          token,
          appId: wxMpAppid
        }
      })
    if (code !== 400 || getUrlParam('autoOauth') != '') {
      return Promise.resolve(true)
    }
    location.replace(goOauthUrl)
  } catch (error) {
    console.log('[OAUTH]', error)
  }
}
